export enum ImageOrderingTracingMessages {
  capability = 'Image Ordering Upload',
  event = 'Image Upload',
}
